import { useEffect } from 'react';
import { useTranslation } from '@src/i18n';
import { hostBridge } from '@src/messaging/hostBridge';
import './LoadingPage.css';
import './ExitedPage.css';

interface ExitedPageProps {
    /** Called after the exit signal is sent, to reset flow state. */
    onDone: () => void;
}

const DONE_DISPLAY_MS = 5000;

export function ExitedPage({ onDone }: ExitedPageProps) {
    const { t } = useTranslation();

    useEffect(() => {
        hostBridge.exit();
        const timer = setTimeout(onDone, DONE_DISPLAY_MS);
        return () => clearTimeout(timer);
    }, [onDone]);

    return (
        <main className="loading-page" aria-live="polite">
            <p className="exited-page__message">{t('externalUser.done')}</p>
        </main>
    );
}
